export default __webpack_public_path__ + "static/media/vk.f9cbdfe6.svg";